import { render } from "./PorKleg.vue?vue&type=template&id=42637acf"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/PorKleg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42637acf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42637acf', __exports__)) {
    api.reload('42637acf', __exports__)
  }
  
  module.hot.accept("./PorKleg.vue?vue&type=template&id=42637acf", () => {
    api.rerender('42637acf', render)
  })

}


export default __exports__